import { gridHeaders } from "../../const";
import { createPortal } from "react-dom";
import { useRef, useEffect, useMemo, useState, forwardRef } from "react";
import {
  getFieldValuesByTableAndId,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import "../../css/StyleRenderer.css";
import { measureTextWidth } from "../../helper";
import { Gift } from "react-feather";
import { toast } from "react-toastify";
import { formatFromJsonDate } from "../../dateConfig";

export function ActiveCellStyle(params) {
  const active = params.value != null ? String(params.value).toLowerCase() : "";
  if (active === "active") {
    return <div className="ui green horizontal label">Active</div>;
  } else if (active === "deleted") {
    return <div className="ui red horizontal label">Deleted</div>;
  } else {
    return <div className="ui horizontal label">other</div>;
  }
}

export function EVInvCellStyle(params) {
  const label = params.value;

  switch (label) {
    case "Pending":
      return <div className="ui orange horizontal label">{label}</div>;

    case "Partially Generated":
      return <div className="ui yellow horizontal label">{label}</div>;

    case "Generated":
      return (
        <div
          className="ui horizontal label"
          style={{ backgroundColor: "#81c784" }}
        >
          {label}
        </div>
      );

    case "Approved":
      return <div className="ui green horizontal label">{label}</div>;

    case "Rejected":
      return <div className="ui red horizontal label">{label}</div>;

    case "Completed":
      return (
        <div
          className="ui horizontal label"
          style={{ backgroundColor: "#4caf50" }}
        >
          {label}
        </div>
      );

    default:
      return <div className="ui horizontal label">Other</div>;
  }
}

export function AsyncEVInvCellStyle(params) {
  const [label, setLabel] = useState("Loading...");
  useEffect(() => {
    (async () => {
      const labelName = await getTextByValueAndKey(
        "ev_inv_status",
        params.value,
      );
      setLabel(labelName);
    })();
  }, [params.value]);
  switch (params.value) {
    case 1: {
      return <div className="ui orange horizontal label">{label}</div>;
    }
    case 2: {
      return (
        <div
          className="ui horizontal label"
          style={{ backgroundColor: "#81c784" }}
        >
          {label}
        </div>
      );
    }
    case 3: {
      return <div className="ui green horizontal label">{label}</div>;
    }
    case 4: {
      return <div className="ui red horizontal label">{label}</div>;
    }
    case 5: {
      return (
        <div
          className="ui horizontal label"
          style={{ backgroundColor: "#4caf50" }}
        >
          {label}
        </div>
      );
    }
    default: {
      return <div className="ui horizontal label">Other</div>;
    }
  }
}

export function ChargeCellStyle(params) {
  const flag = params.value;
  if (flag) {
    return <div className="ui green horizontal label">Added</div>;
  } else {
    return <div className="ui red horizontal label">Not Available</div>;
  }
}

export function DateTimeCellRenderer(params) {
  if (!params.value) return "N/A";
  return formatFromJsonDate(params.value);
}

export function DateCellRenderer(params) {
  // if (!params.value) return "";
  // const date = new Date(params.value);
  // return date.toLocaleDateString("en-GB");
  if (!params.value) return "";
  const date = new Date(params.value);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  return `${formattedDate} / ${formattedTime}`;
}

export function DateOnlyCellRenderer(params) {
  if (!params.value) return "";
  const date = new Date(params.value);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return `${formattedDate}`;
}

export function StatusCellStyle(params) {
  const status = params.value != null ? String(params.value).toLowerCase() : "";
  if (status === "pending") {
    return <div className="ui orange horizontal label">Pending</div>;
  } else if (status === "approved") {
    return <div className="ui green horizontal label">Approved</div>;
  } else if (status === "rejected") {
    return <div className="ui red horizontal label">Rejected</div>;
  } else if (status === "completed") {
    return <div className="ui green horizontal label">Completed</div>;
  } else if (status === "partially approved") {
    return <div className="ui yellow horizontal label">Partially Approved</div>;
  } else if (status === "blacklisted") {
    return <div className="ui black horizontal label">Blacklisted</div>;
  } else if (status === "deleted") {
    return <div className="ui red horizontal label">Deleted</div>;
  } else if (status === "closed") {
    return <div className="ui brown horizontal label">Closed</div>;
  } else if (status === "inactive") {
    return <div className="ui grey horizontal label">Inactive</div>;
  } else if (status === "hold") {
    return <div className="ui red horizontal label">Hold</div>;
  } else if (status === "release") {
    return <div className="ui green en horizontal label">Release</div>;
  } else if (status === "inactive") {
  } else {
    return <div className="ui horizontal label">Other</div>;
  }
}

export function IssueStatusCellStyle(params) {
  const status = String(params.value || "").toLowerCase();

  const labelStyle = {
    minWidth: "120px",
    textAlign: "center",
  };

  if (status === "open") {
    return <div className="ui blue small horizontal label" style={labelStyle}>Open</div>;
  } else if (status === "overdue") {
    return <div className="ui red small horizontal label" style={labelStyle}>Overdue</div>;
  } else if (status === "resolved") {
    return <div className="ui green small horizontal label" style={labelStyle}>Resolved</div>;
  } else if (status === "closed") {
    return <div className="ui grey small horizontal label" style={labelStyle}>Closed</div>;
  } else if (status === "on hold") {
    return <div className="ui purple small horizontal label" style={labelStyle}>On Hold</div>;
  } else if (status === "in progress") {
    return <div className="ui orange small horizontal label" style={labelStyle}>In Progress</div>;
  } else {
    return <div className="ui small horizontal label" style={labelStyle}>Other</div>;
  }
}

export function LabelCellStyle({
  value,
  color,
  width = "100%",
  height = "100%",
}) {
  return (
    <>
      {color ? (
        <div
          className="ui horizontal label"
          style={{
            backgroundColor: color,
            color: "white",
            width,
            height,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {value}
        </div>
      ) : (
        <div className="ui primary horizontal label">{value}</div>
      )}
    </>
  );
}



export function StatusLabelStyle(params) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: params.height ? params.height : "50px",
      }}
    >
      <div
        className="ui white horizontal label"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.7)",
        }}
      >
        <div
          style={{
            wordWrap: "break-word",
            width: "120px",
            whiteSpace: "normal",
          }}
        >
          {params.value}
        </div>
      </div>
    </div>
  );
}
/* ---------- Portal tooltip (clean card) ---------- */
function ResizableScrollTooltip({
  anchorEl,
  text,
  onClose,
  onEnter,
  title = "Full value",
}) {
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (!anchorEl) return;
    const update = () => {
      const r = anchorEl.getBoundingClientRect();
      const margin = 6;
      const left = Math.max(8, Math.min(r.left, window.innerWidth - 560));
      setPos({
        top: r.bottom + margin + window.scrollY,
        left: left + window.scrollX,
        width: r.width,
      });
    };
    update();
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
    };
  }, [anchorEl]);

  if (!anchorEl) return null;

  return createPortal(
    <div
      className="resizable-scroll-tooltip"
      style={{
        top: pos.top,
        left: pos.left,
        minWidth: Math.max(320, pos.width),
      }}
      onMouseLeave={onClose}
      onMouseEnter={() =>
        onEnter && onEnter()
      } /* keep open when cursor enters tooltip */
      role="dialog"
      aria-label="Cell value"
    >
      <div className="resizable-scroll-tooltip-header">
        <button
          className="resizable-scroll-tooltip-close"
          onClick={onClose}
          title="Close"
        >
          ✕
        </button>
      </div>
      <div className="resizable-scroll-tooltip-body">
        <div className="resizable-scroll-tooltip-text" title={text}>
          {text}
        </div>
      </div>
    </div>,
    document.body,
  );
}

/* ---------- Cell renderer (uses old classes) ---------- */
export const ResizableScrollingTextRenderer = forwardRef(
  (
    {
      value,
      threshold = 20,
      width = "180px",
      isCustomValue = false,
      customValue,
      isBirthday = false,
      /* TUNE SPEED HERE: raise for faster (e.g., 48–55) */
      pixelsPerSecond = 50,
      showTooltip = true,
      ...prop
    },
    ref,
  ) => {
    const [currentWidth, setCurrentWidth] = useState(width);
    const [scroll, setScroll] = useState(true);

    const containerRef = useRef(null);
    const textRef = useRef(null);

    // tooltip state
    const [tipOpen, setTipOpen] = useState(false);
    const leaveTimer = useRef(null);

    // single-click copy (double-click cancels)
    const singleClickTimerRef = useRef(null);
    const SINGLE_CLICK_DELAY = 250;

    const currentValue = isCustomValue ? customValue : value;

    // distance & duration for constant speed
    const [scrollDistance, setScrollDistance] = useState(0);
    const [scrollDuration, setScrollDuration] = useState("14s");

    useEffect(() => {
      const wEstimate = measureTextWidth(currentValue || "");
      const actualWidth = prop?.column?.actualWidth
        ? parseFloat(prop.column.actualWidth)
        : 0.0;

      const usable = Math.max(actualWidth - 30.0, 0); // leave room for padding/icons
      setCurrentWidth(usable);
      setScroll(wEstimate > usable);

      // measure after paint
      requestAnimationFrame(() => {
        const cW = containerRef.current?.offsetWidth ?? usable;
        const tW = textRef.current?.scrollWidth ?? wEstimate;

        if (tW > cW && pixelsPerSecond > 0) {
          const dist = tW + cW * 0.1; // total distance including a small buffer
          const durSec = Math.max(dist / pixelsPerSecond, 1);
          setScrollDistance(dist);
          setScrollDuration(`${durSec.toFixed(2)}s`);
        } else {
          setScrollDistance(0);
          setScrollDuration("0s");
        }
      });
    }, [currentValue, prop?.column?.actualWidth, pixelsPerSecond]);

    useEffect(() => {
      return () => {
        if (singleClickTimerRef.current)
          clearTimeout(singleClickTimerRef.current);
        if (leaveTimer.current) clearTimeout(leaveTimer.current);
      };
    }, []);

    const doCopy = async () => {
      if (!currentValue) return;
      try {
        await navigator.clipboard.writeText(currentValue);
        toast.success("Copied to clipboard!", {
          autoClose: 2000,
          containerId: "Main",
        });
      } catch {
        toast.error("Failed to copy to clipboard", {
          autoClose: 2000,
          containerId: "Main",
        });
      }
    };

    const handleClick = (e) => {
      e.stopPropagation();
      if (e.detail === 1) {
        if (singleClickTimerRef.current)
          clearTimeout(singleClickTimerRef.current);
        singleClickTimerRef.current = setTimeout(() => {
          doCopy();
          singleClickTimerRef.current = null;
        }, SINGLE_CLICK_DELAY);
      } else {
        if (singleClickTimerRef.current) {
          clearTimeout(singleClickTimerRef.current);
          singleClickTimerRef.current = null;
        }
      }
    };

    const handleDoubleClick = (e) => {
      e.stopPropagation(); // cancels copy
    };

    // Tooltip open/close with grace period; cancel close when entering tooltip
    const cancelClose = () => {
      if (leaveTimer.current) {
        clearTimeout(leaveTimer.current);
        leaveTimer.current = null;
      }
    };
    const openTip = () => {
      if (!showTooltip || !currentValue) return;
      cancelClose();
      setTipOpen(true);
    };
    const closeTip = () => {
      cancelClose();
      leaveTimer.current = setTimeout(() => setTipOpen(false), 120);
    };

    return (
      <>
        <div
          ref={containerRef}
          className={
            scroll && currentValue && currentValue.length > threshold
              ? "scrolling-container"
              : ""
          }
          style={{
            position: "relative",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: currentWidth,
            cursor: currentValue ? "pointer" : "default",
          }}
          onClick={handleClick}
          onDoubleClick={handleDoubleClick}
          onMouseEnter={openTip}
          onMouseLeave={closeTip}
          /* no title attr → avoids native black tooltip */
        >
          <div
            ref={textRef}
            className={
              scroll && currentValue && currentValue.length > threshold
                ? "scrolling-text"
                : "static-text"
            }
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
              /* CSS variables consumed by @keyframes scroll */
              "--scroll-distance": `${scrollDistance}px`,
              "--scroll-duration": scrollDuration,
            }}
          >
            <span>{currentValue}</span>
            {isBirthday && (
              <Gift size={18} color="red" title="Driver Birthday Today" />
            )}
          </div>
        </div>

        {tipOpen && (
          <ResizableScrollTooltip
            anchorEl={containerRef.current}
            text={currentValue}
            onClose={() => setTipOpen(false)}
            onEnter={cancelClose}
          />
        )}
      </>
    );
  },
);

export const ScrollingTextRenderer = ({
  value,
  threshold = 20,
  width = "180px",
  isCustomValue = false,
  customValue,
}) => {
  const currentValue = isCustomValue ? customValue : value;
  return (
    <div
      className={
        currentValue && currentValue.length > threshold
          ? "scrolling-container"
          : ""
      }
      style={
        currentValue && currentValue.length > threshold ? { width: width } : {}
      }
    >
      <div
        className={
          currentValue && currentValue.length > threshold
            ? "scrolling-text"
            : "static-text"
        }
      >
        {currentValue}
      </div>
    </div>
  );
};

export const AsyncDropdownValueRenderer = (params) => {
  const [label, setLabel] = useState(params.value != null && params.value !== "" ? "Loading..." : "");
  useEffect(() => {
    if (params.value == null || params.value === "") {
      setLabel("");
      return;
    }
    (async () => {
      try {
        const labelName = await getTextByValueAndKey(
          params.dropdownKey,
          params.value,
        );
        setLabel(labelName || "");
      } catch (err) {
        setLabel("");
      }
    })();
  }, [params.dropdownKey, params.value]);

  return label;
};

export const AsyncOtherRefDropdownValueRenderer = ({
  value,
  tableName,
  primaryKey,
  fieldName,
}) => {
  const [label, setLabel] = useState(value != null && value !== "" ? "Loading..." : "");
  useEffect(() => {
    if (value == null || value === "") {
      setLabel("");
      return;
    }
    (async () => {
      try {
        const labelRes = await getFieldValuesByTableAndId({
          tableName,
          primaryKey,
          fieldNames: fieldName,
          ids: value.toString(),
        });
        setLabel(labelRes && labelRes.length > 0 ? labelRes[0].field1 || "" : "");
      } catch (err) {
        setLabel("");
      }
    })();
  }, [fieldName, primaryKey, tableName, value]);

  return label;
};

export const CurrencyRenderer = ({
  value,
  formatter,
  otherProp = false,
  ...prop
}) => {
  return formatter
    ? formatter.format(otherProp ? prop.currentValue : value)
    : value;
};

export const DynamicCurrencyRenderer = ({ value, currencyCode, ...prop }) => {
  const formatter = useMemo(
    () =>
      currencyCode
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencyCode,
          })
        : null,
    [currencyCode],
  );
  return formatter === null ? value : formatter.format(value);
};

export function chargeCreationStatusLabelStyle(params) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60px",
      }}
    >
      <div
        className="ui white horizontal label"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.7)",
        }}
      >
        <div
          style={{
            wordWrap: "break-word",
            width: "120px",
            whiteSpace: "normal",
          }}
        >
          {params.value}
        </div>
      </div>
    </div>
  );
}

export function JobStatusStyle(params) {
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <div
        className="ui horizontal label"
        style={{
          backgroundColor: params.data.staColor,
        }}
      >
        {params.value}
      </div>
    </div>
  );
}

export function VehicleAssignmentStyle(params) {
  const gpsActive = params.data.gpsActive;
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <div
        className="ui horizontal label"
        style={{
          backgroundColor:
            params.value === "Vehicle not assigned"
              ? "grey"
              : gpsActive
                ? "rgb(76, 175, 80)"
                : "grey",
          color: "white",
        }}
      >
        {params.value === "Vehicle not assigned" ? "No Vehicle" : params.value}
      </div>
    </div>
  );
}

export const RemarkFlagRenderer = ({ params, type }) => {
  let data = type === gridHeaders.FLAG ? "No Flags" : "No Remarks";
  let hasData = false;
  let resolved = false;
  let accepted = false;
  if (type === gridHeaders.REMARKS && params.data.latestRemark !== null) {
    const remarkArray = params.data.latestRemark.split(",");
    data = "Remarks";
    hasData = true;
    resolved = remarkArray[1] === "Resolved";
    accepted = remarkArray[1] === "Accepted";
  }

  if (type === gridHeaders.FLAG && params.data.latestFlag !== null) {
    const flagArray = params.data.latestFlag.split(",");
    data =
      flagArray[1].trim() === "Resolved"
        ? "Flags"
        : flagArray[1].trim() === "Accepted"
          ? "Accepted Flag"
          : "Unresolved Flag";
    hasData = true;
    resolved = flagArray[1].trim() === "Resolved";
    accepted = flagArray[1].trim() === "Accepted";
  }
  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="ui horizontal label"
        style={{
          backgroundColor:
            hasData && type === gridHeaders.FLAG
              ? resolved
                ? "rgb(76, 175, 80)"
                : accepted
                  ? "rgb(208, 201, 99)"
                  : "#ef5350"
              : "grey",
          color: "white",
        }}
      >
        {data}
      </div>
    </>
  );
};

export function BulkProceedStatusStyle(params) {
  const status = params.value != null ? String(params.value).toLowerCase() : "";
  if (status === "pending") {
    return <div className="ui green horizontal label">Pending</div>;
  } else if (status === "failed") {
    return <div className="ui red horizontal label">Failed</div>;
  } else if (status === "completed") {
    return <div className="ui red horizontal label">Completed</div>;
  } else {
    return <div className="ui horizontal label">Other</div>;
  }
}

const SoftLabel = ({ text, bgColor, textColor }) => {
  return (
    <div
      style={{
        minWidth: "110px",
        textAlign: "center",
        padding: "6px 12px",
       // borderRadius: "20px",
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 500,
        margin: "0 auto",
      }}
    >
      {text}
    </div>
  );
};

export function PriorityCellStyle(params) {
  const value = String(params.value || "").toLowerCase();

  if (value === "high") {
    return <SoftLabel text="High" bgColor="#fde2e2" textColor="#a8071a" />;
  } else if (value === "medium") {
    return <SoftLabel text="Medium" bgColor="#fff4e5" textColor="#ad6800" />;
  } else if (value === "low") {
    return <SoftLabel text="Low" bgColor="#e6f4ea" textColor="#237804" />;
  } else if (value === "critical") {
    return <SoftLabel text="Critical" bgColor="#eeeeee" textColor="#333" />;
  } else {
    return <SoftLabel text={params.value || "N/A"} bgColor="#f5f5f5" textColor="#333" />;
  }
}

export function IssuePriorityCellStyle(params) {
  const priority = String(params.value || "").toLowerCase();

  if (priority === "high") {
    return <div className="ui red horizontal label">High</div>;
  } else if (priority === "medium") {
    return <div className="ui yellow horizontal label">Medium</div>;
  } else if (priority === "low") {
    return <div className="ui green horizontal label">Low</div>;
  }  else if (priority === "critical") {
    return <div className="ui orange horizontal label">Critical</div>;
  } else {
    return <div className="ui horizontal label">{params.value || "Other"}</div>;
  }
}
